import { QueryConfig } from "store/utils/query-config";

export const callLogsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-initiatedAt"]
  }
};
